import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReportService } from '../../_services';
import { GlobalDataService } from '../../_shared';
import {  Supplier, LoginUser } from '../../_models';
import * as XLSX from 'xlsx'; 
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { CurrencyPipe } from '@angular/common';
@Component({
  selector: 'app-aging-report',
  templateUrl: './aging-report.component.html',
  styleUrls: ['./aging-report.component.css']
})
export class AgingReportComponent implements OnInit {
  suppliersResult: Supplier[] = [];
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs: string[] = [];
  user: LoginUser = new LoginUser;
   SupplierAB='';
   ObjectAccount = '';  
   Year = '';  
  arrayList: Array<string> = [];
  AgingResult: any[] = [];
  keys: string[] = [];
  type!: any;
  title='';
  columnNames: any[] = [];
  data : any[] = [];
  graphData : any[] = [];
  options!: {};
  width=0;
  height=0;
  count=0;
  ApprDt: any;
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  
  
  constructor( private reportService  : ReportService,
    private gd : GlobalDataService,private currencyPipe:CurrencyPipe) { }
  
  ngOnInit() {
    this.user = this.gd.getUserData();
    this.GetApprovedDate();
    this.getSuppliers();
    this.getObjectAccount();
  }

  GetApprovedDate(){
    this.reportService.getApprovedDate().subscribe(res => {
      if(res!=null)
      {
        this.ApprDt = {
          "year": new Date(res.ApproveDate).getFullYear(),
          "month":  new Date(res.ApproveDate).getMonth()+1,
          "day": new Date(res.ApproveDate).getDate()
        }
      }
    });
  }

  getSuppliers()
  {
    
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  getAcurlYr()
  {
    this.reportService.getAccurlYrs().subscribe(data=>{
      this.getYrs = data;
    });
  }

  getObjectAccount()
  {
   
    this.objectAccountsResult=this.gd.getAccountData();
  }

  search(seachData? : any){
    this.graphData=[];
    this.data=[];
    this.reportService.getAgingDetails(this.SupplierAB==null || this.SupplierAB =='' ?'': (this.SupplierAB.split('-')[0]),this.ObjectAccount.split('-')[0],this.gd.convertToStandardDate(this.ApprDt)).subscribe(data=>{
      this.AgingResult = data;
       
      this.keys=Object.keys(this.AgingResult[0]);
      this.data.push(data);
          var vals: any[]=[];
          for(var i=0;i<this.data[0].length;i++){
            vals.push(this.data[0][i].Aging);
            vals.push(parseInt(this.data[0][i].Jan)); 
            vals.push(parseInt(this.data[0][i].Feb));
            vals.push(parseInt(this.data[0][i].Mar));
            vals.push(parseInt(this.data[0][i].Apr)); 
            vals.push(parseInt(this.data[0][i].May));
            vals.push(parseInt(this.data[0][i].Jun));
            vals.push(parseInt(this.data[0][i].Jul)); 
            vals.push(parseInt(this.data[0][i].Aug));
            vals.push(parseInt(this.data[0][i].Sep));
            vals.push(parseInt(this.data[0][i].Oct));
            vals.push(parseInt(this.data[0][i].Nov));
            vals.push(parseInt(this.data[0][i].Dec));
            this.graphData.push(vals);
            vals=[];
         }
          this.InitlizeGraphdata();
          this.count = this.graphData.length;
          for (let i=0;i<this.AgingResult.length;i++)
      {
        this.AgingResult[i].Jan = this.currencyPipe.transform(this.AgingResult[i].Jan);
        this.AgingResult[i].Feb = this.currencyPipe.transform(this.AgingResult[i].Feb);
        this.AgingResult[i].Mar = this.currencyPipe.transform(this.AgingResult[i].Mar);
        this.AgingResult[i].Apr = this.currencyPipe.transform(this.AgingResult[i].Apr);
        this.AgingResult[i].May = this.currencyPipe.transform(this.AgingResult[i].May);
        this.AgingResult[i].Jun = this.currencyPipe.transform(this.AgingResult[i].Jun);
        this.AgingResult[i].Jul = this.currencyPipe.transform(this.AgingResult[i].Jul);
        this.AgingResult[i].Aug = this.currencyPipe.transform(this.AgingResult[i].Aug);
        this.AgingResult[i].Sep = this.currencyPipe.transform(this.AgingResult[i].Sep);
        this.AgingResult[i].Oct = this.currencyPipe.transform(this.AgingResult[i].Oct);
        this.AgingResult[i].Nov = this.currencyPipe.transform(this.AgingResult[i].Nov);
        this.AgingResult[i].Dec = this.currencyPipe.transform(this.AgingResult[i].Dec);
        this.AgingResult[i].Total = this.currencyPipe.transform(this.AgingResult[i].Total);
      } 
    });
  }

  InitlizeGraphdata(){
    this.type = 'ColumnChart';
    this.title = 'Aging Report';
    this.columnNames = ["ColumnName","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    this.options = {
    hAxis : {title:'Aging'},
    vAxis : {title:'Values'}
    };
    this.width = 700;
    this.height = 1000;
  }
  
  ExportTOExcel() {  
 
     var reportGrid = document.getElementById("reportGrid_all");
          var wb: XLSX.WorkBook = XLSX.utils.book_new();
          let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
          wb.SheetNames.push("Sheet1");
          wb.Sheets["Sheet1"] = ws;
      
          /* save to file */
          XLSX.writeFile(wb, 'AgingReport' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  }  
  
  
}
